module.exports = "/images/logo-neg.svg?19d4779434d504cf5c80b059e10c33a6";